import { Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { Map as MapIcon } from '@/components/ui/icons'
import { Pressable } from '@/components/ui/Pressable'
import { FONTS, RADIUS, SPACING } from '@/lib/brand'
import { INTERACTION } from '@/lib/theme/tokens'

export function TourRouteMapFallback({
  colors,
  height,
  testID,
  title,
  body,
  onRetry,
}: {
  colors: {
    surfaceSubtle: string
    border: string
    textMuted: string
    textPrimary: string
    textSecondary: string
    textAccent: string
    surface: string
  }
  height: number
  testID?: string
  title: string
  body?: string
  onRetry?: () => void
}) {
  const { t } = useTranslation()
  return (
    <View
      style={{
        height,
        alignItems: 'center',
        justifyContent: 'center',
        gap: SPACING.sm,
        paddingHorizontal: SPACING.lg,
        borderRadius: RADIUS.xl,
        borderWidth: 1,
        borderColor: colors.border,
        backgroundColor: colors.surfaceSubtle,
      }}
      testID={testID}
    >
      <MapIcon size={32} color={colors.textMuted} strokeWidth={1.5} />
      <Text
        style={{
          fontFamily: FONTS.body,
          fontSize: 14,
          lineHeight: 20,
          color: colors.textPrimary,
          textAlign: 'center',
        }}
      >
        {title}
      </Text>
      {body ? (
        <Text
          style={{
            fontFamily: FONTS.body,
            fontSize: 13,
            lineHeight: 18,
            color: colors.textSecondary,
            textAlign: 'center',
            maxWidth: 320,
          }}
        >
          {body}
        </Text>
      ) : null}
      {onRetry ? (
        <Pressable
          onPress={onRetry}
          accessibilityRole="button"
          accessibilityLabel={t('tours.retry')}
          testID="tours.map-retry"
          style={{
            minHeight: INTERACTION.minTouchTarget,
            minWidth: INTERACTION.minTouchTarget,
            paddingHorizontal: SPACING.lg,
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: RADIUS.full,
            borderWidth: 1,
            borderColor: colors.border,
            backgroundColor: colors.surface,
          }}
        >
          <Text style={{ fontFamily: FONTS.body, fontSize: 14, color: colors.textAccent }}>
            {t('tours.retry')}
          </Text>
        </Pressable>
      ) : null}
    </View>
  )
}
